// extracted by mini-css-extract-plugin
export var carrierNotice = "_lb-5";
export var carrierNoticePlaceholder = "_lb-6";
export var deliveryRow = "_lb-c";
export var fixedHeight = "_lb-4";
export var freightLogo = "_lb-b";
export var fullWidth = "_lb-3";
export var priceColumn = "_lb-7";
export var radioSelected = "_lb-9";
export var radioUnselected = "_lb-8";
export var selectedOption = "_lb-2";
export var selectedOptionContainer = "_lb-1";
export var selection = "_lb-0";
export var tallSkeletonText = "_lb-a";